import type { PropsWithChildren } from "react"
import { Logo } from "~/components/ui"
import { LanguageSwitcher } from "../default/language-switcher"

type OnlyLogoLayoutProps = PropsWithChildren<{
  showLanguageSwitcher?: boolean
}>

export function OnlyLogoLayout({
  children,
  showLanguageSwitcher,
}: OnlyLogoLayoutProps) {
  return (
    <div className="flex flex-col h-dvh">
      <header className="flex items-center justify-between pt-8 pb-0 px-16">
        <Logo />
        {showLanguageSwitcher && <LanguageSwitcher />}
      </header>
      <main className="flex flex-1 w-full justify-center">{children}</main>
    </div>
  )
}
